import { Box, BoxProps, ColorOptions, convertHexToRGBA, Text } from '@jfs/ui-new'
import { createMaterialTopTabNavigator } from '@react-navigation/material-top-tabs'
import { FC, memo } from 'react'
import { Colors } from '../../util/util'

const Tab = createMaterialTopTabNavigator()

interface TopTabNavigatorProps {
  tabs: any
  onTabChange?: any
  fetchTxnColumns?: any
  fetchRefunds?: any
  fetchTxn?: any
  fetchStatsApi?: any
  refundApiHandlers?: any
  transactionApiHandlers?: any
  settlementApiHandler?: any
  onListScroll?: any
  fetchTxnColumnsOnLoadMore?: any
  fetchRefundsOnLoadMore?: any
  fetchTxnOnLoadMore?: any
  refundApiLoadMoreHandlers?: any
  transactionApiLoadMoreHandlers?: any
  type?: any
  isFocused?: any
}

const TopTabNavigator: FC<TopTabNavigatorProps> = ({ tabs, onTabChange, ...extraProps }: TopTabNavigatorProps) => {
  return (
    <Tab.Navigator tabBar={(props) => <CustomTabView {...props} onTabChange={onTabChange} />}>
      {tabs.map((tab: any) => (
        <Tab.Screen name={tab.name} children={(props) => <tab.component {...props} {...extraProps} />} key={tab.name} />
      ))}
    </Tab.Navigator>
  )
}

export default memo(TopTabNavigator)

const CustomTabView = ({ state, descriptors, navigation, onTabChange }: any) => {
  return (
    <Box>
      <Box {...styles.container}>
        {state.routes.map((route, index) => {
          const { options } = descriptors[route.key]
          const label =
            options.tabBarLabel !== undefined
              ? options.tabBarLabel
              : options.title !== undefined
                ? options.title
                : route.name

          const isFocused = state.index === index

          const onPress = () => {
            const event = navigation.emit({
              type: 'tabPress',
              target: route.key,
              canPreventDefault: true,
            })

            if (!isFocused && !event.defaultPrevented) {
              navigation.navigate(route.name)
            }
            onTabChange && onTabChange(index)
          }

          return (
            <Box
              accessibilityLabel={options.tabBarAccessibilityLabel}
              testID={options.tabBarTestID}
              onPress={onPress}
              h={48}
              ph={8}
              mr={16}
              justify={'center'}
              underlayColor={'GRAY_BORDER'}
              borderBottomWidth={isFocused ? 2 : 0}
              borderBottomColor={Colors.PRIMARY as ColorOptions}
              key={label}
              bg={'WHITE'}>
              <Text
                color={isFocused ? (Colors.PRIMARY as ColorOptions) : (Colors.BLACK_14 as ColorOptions)}
                fontSize={14}
                lineHeight={20}
                textAlign={'center'}
                letterSpacing={-0.07}
                fontFamily={isFocused ? 'JioType-Bold' : 'JioType-Medium'}>
                {label}
              </Text>
            </Box>
          )
        })}
      </Box>
      <Box height="1px" alignSelf="stretch" backgroundColor={'#F5F5F5' as ColorOptions} />
    </Box>
  )
}

const styles = {
  container: {
    flexDirection: 'row',
    backgroundColor: 'WHITE',
    borderTopLeftRadius: 24,
    borderTopRightRadius: 24,
    ph: 24,
    borderBottomWidth: 1,
    borderBottomColor: convertHexToRGBA(Colors.BLACK, 12) as ColorOptions,
  } as BoxProps,
}
